export default __webpack_public_path__ + "static/media/logo-with-text.1af9f07f.png";